"use strict";

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (e.__proto__ = t);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _createClass = function () {
  function e(e, t) {
    for (var o = 0; o < t.length; o++) {
      var r = t[o];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  return function (t, o, r) {
    return o && e(t.prototype, o), r && e(t, r), t;
  };
}(),
    _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    ReactSoundcloud = function (e) {
  function t() {
    _classCallCheck(this, t), null != e && e.apply(this, arguments);
  }

  return _inherits(t, e), _createClass(t, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.url,
          o = e.width,
          r = e.height,
          a = e.autoPlay,
          u = e.hideRelated,
          s = e.showComments,
          n = e.showUser,
          l = e.showReposts,
          c = e.visual,
          i = e.color,
          p = c ? "https://w.soundcloud.com/player/?url=" + t + "&amp;auto_play=" + a + "&amp;hide_related=" + u + "&amp;show_comments=" + s + "&amp;show_user=" + n + "&amp;show_reposts=" + l + "&amp;visual=" + c : "https://w.soundcloud.com/player/?url=" + t + "&amp;color=" + i + "&amp;auto_play=" + a + "&amp;hide_related=" + u + "&amp;show_comments=" + s + "&amp;show_user=" + n + "&amp;show_reposts=" + l;
      return _react2["default"].createElement("iframe", {
        width: o,
        height: c ? r : "auto",
        scrolling: "no",
        frameborder: "no",
        src: p
      });
    }
  }], [{
    key: "defaultProps",
    value: {
      width: "100%",
      height: "450px",
      url: "https://soundcloud.com/icebound/dusty-breaks-at-the-bottom-of-the-random-crates",
      autoPlay: !1,
      hideRelated: !1,
      showComments: !0,
      showUser: !0,
      showReposts: !1,
      visual: !0,
      color: "ff5500"
    },
    enumerable: !0
  }]), t;
}(_react.Component);

exports["default"] = ReactSoundcloud, module.exports = exports["default"];